'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'App');

var authorService = abp.services.api.author;

(0, _jquery2.default)(document).on('click', '#btn-add-watchdog-author-confirmation-submit', function () {
    var authorId = (0, _jquery2.default)("#AuthorId").val();

    authorService.addWatchdogByAuthorId(authorId).done(function () {
        (0, _jquery2.default)('#btn-add-new-watchdog').addClass("hidden");
        (0, _jquery2.default)('#btn-remove-watchdog').removeClass("hidden");

        _notify2.default.success(Resx.App.WatchDogAdded);
    }).fail(function (result) {
        _notify2.default.error(result.responseJSON.error.message);
    });
});

(0, _jquery2.default)(document).on('click', '#btn-remove-watchdog-author-confirmation-submit', function () {
    var authorId = (0, _jquery2.default)("#AuthorId").val();
    authorService.removeWatchdogByAuthorId(authorId).done(function () {
        (0, _jquery2.default)('#btn-add-new-watchdog').removeClass("hidden");
        (0, _jquery2.default)('#btn-remove-watchdog').addClass("hidden");
        _notify2.default.success(Resx.App.WatchDogRemoved);
    }).fail(function (result) {
        _notify2.default.error(result.responseJSON.error.message);
    });
});

(0, _jquery2.default)(document).on('click', '#btn-remove-watchdog-author-all', function () {
    _message2.default.confirm(Resx.App.WatchDogAllRemoveConfirmation, Resx.Messages.ConfirmTitle, function (isConfirmed) {
        if (isConfirmed) {
            authorService.removeAllWatchdogs().done(function () {
                (0, _jquery2.default)("#customerWatchdogAuthorGrid").DataTable().ajax.reload(null, false);
                (0, _jquery2.default)("#btn-remove-watchdog-author-all").removeClass('hidden');
                (0, _jquery2.default)("#btn-remove-watchdog-author-all").addClass('hidden');
                _notify2.default.success(Resx.App.WatchDogAllRemoved);
            }).fail(function (result) {
                _notify2.default.error(result.responseJSON.error.message);
            });
        }
    });
});

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/watchdogAuthor.js
// module id = 1097
// module chunks = 1